import { Component, EventEmitter, Output } from '@angular/core';
import { ArkikSpinnerOptions } from './arkik-spinner-options';
import { animate, AnimationEvent, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'arkik-spinner',
  template: `
    <cwc-loader
      [@spinner]="toState"
      (@spinner.done)="onAnimationDone($event)"
      [delayMessageTime]="options.delayMessage"
      [errorMessageTime]="options.errorTime"
      size="large"
    >
      <span slot="delay" *ngIf="options.delayMessage">{{ options.delayMessage }}</span>
      <span slot="error" *ngIf="options.errorMessage">{{ options.errorMessage }}</span>
    </cwc-loader>
  `,
  styles: [
    `
      :host {
        width: 100%;
        height: 100svh;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(0, 0, 0, 0.15);
      }
    `,
  ],
  animations: [
    trigger('spinner', [
      state('void', style({ transform: 'scale(0.5)', opacity: 0 })),
      transition('void => show', animate('0.2s ease-out', style({ transform: 'none' }))),
      transition('show => void', animate('0.15s ease-in', style({ transform: 'scale(0.5)', opacity: 0 }))),
    ]),
  ],
})
export class ArkikSpinnerComponent {
  @Output() closeAnimationDone = new EventEmitter<void>();
  @Output() closeToOpen = new EventEmitter<void>();

  toState: 'show' | 'void' = 'show';

  private _nextSpinner = false;

  constructor(public options: ArkikSpinnerOptions) {}

  onClose(nextSpinner: boolean = false): void {
    this._nextSpinner = nextSpinner;
    this.toState = 'void';
  }

  onAnimationDone({ toState }: AnimationEvent): void {
    !this._nextSpinner && toState === 'void' && this.closeAnimationDone.next();
    this._nextSpinner && toState === 'void' && this.closeToOpen.next();
  }
}
